import swal from 'sweetalert';
import { getCookie } from './cookie.js';

export async function getGstinSearchDetails(gstin, organization_id, page_name, email) {
    const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/get-gstin-search-details`, { method: 'POST', body: JSON.stringify({ gstin: gstin, "email": email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
    );
    const body = await response.json();
    if (body.operation == "success") {
        return body.info[0]
    }
    else {
        swal("Oops!", body.message, "error");
        return null
    }
}